import React from "react";
import ReactDOM from "react-dom";
import "bootstrap";
// Polices auto-hébergées (bundlées par webpack, aucune requête externe).
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";
import "./variables.scss";
import "./animate.css";
import "react-vertical-timeline-component/style.min.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Store from "./context/Store";
import rootReducer from "./context/rootReducer";
import ErrorBoundary from "./helpers/ErrorBoundary";
import { PLATFORM, titreDePlateforme } from "./config";

document.title = titreDePlateforme(PLATFORM);

ReactDOM.render(
  <Store rootReducer={rootReducer}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Store>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
